/**
 * Constants for AI feedback values
 * These values are used to send feedback scores to LangSmith
 */
export const AI_FEEDBACK_SCORE = {
  POSITIVE: 10,
  NEGATIVE: 1,
} as const;
